var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99995 6.39999H12L12.8 13.6H3.19995L3.99995 6.39999Z",
    fill: "#09090B",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6001 4.79999C5.6001 4.16347 5.85295 3.55303 6.30304 3.10294C6.75313 2.65285 7.36358 2.39999 8.0001 2.39999C8.63662 2.39999 9.24707 2.65285 9.69715 3.10294C10.1472 3.55303 10.4001 4.16347 10.4001 4.79999V7.19999C10.4001 7.83651 10.1472 8.44696 9.69715 8.89705C9.24707 9.34714 8.63662 9.59999 8.0001 9.59999C7.36358 9.59999 6.75313 9.34714 6.30304 8.89705C5.85295 8.44696 5.6001 7.83651 5.6001 7.19999V4.79999Z",
    fill: "#09090B",
    stroke: "#09090B",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.40005 8.00001C6.40005 7.55818 6.04188 7.20001 5.60005 7.20001C5.15822 7.20001 4.80005 7.55818 4.80005 8.00001C4.80005 8.44184 5.15822 8.80001 5.60005 8.80001C6.04188 8.80001 6.40005 8.44184 6.40005 8.00001Z",
    fill: "#09090B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2001 8.00001C11.2001 7.55818 10.8419 7.20001 10.4001 7.20001C9.95827 7.20001 9.6001 7.55818 9.6001 8.00001C9.6001 8.44184 9.95827 8.80001 10.4001 8.80001C10.8419 8.80001 11.2001 8.44184 11.2001 8.00001Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag);
export default __webpack_public_path__ + "static/media/ShoppingBag.02f8219ed0e2f8c3b39f9596d2e75e71.svg";
export { ForwardRef as ReactComponent };